<template>
  <div class="scheduleVue" v-loading="loading">
    <div v-if="isEmployeeAllowed">
    <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="o-page-top-heading">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-4">
                        <h1 class="h1">Schedule</h1>
                        <div class="employee-summary-profile employee-summary-profile--inline">
                            <!-- <div class="c-user__profile-pic u-mar-right-10"><img src="images/user2.jpg"></div> -->
                            <div class="employee-summary-profile-pic c-user__profile-pic">
                            <!-- <img src="static/assets/images/user2.jpg" /> -->
                                <img v-if="profileImage != '' && profileImage != 'NULL'" :src="(profileImage)" />
                                <img v-if="profileImage == '' || profileImage == 'NULL'" src="static/assets/images/user1.png" />
                            </div> 
                            <div class="summary-info o-schedule-user">
                                <h1 class="h1">{{employeeName}}</h1> 
                                <p v-for="(phone,index) in employeePhone" :key="index">
                                    <span>{{phone.label}}</span> {{phone.phone_number}}
                                </p>
                                <div v-if="employeePhone.length <= 0">
                                    <p><span>Home Phone:</span> NA</p>
                                    <p><span>Mobile Phone:</span> NA</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-8 text-right" >
                        <div class="row">
                            <!-- <a @click ="editEmployee()" href="javascript: void(0)" class="c-common-btn c-common-btn--inverse-icon-green"><i aria-hidden="true" class="fa fa-pencil"></i> Edit User Profile</a> -->
                            <!-- <input type="text" v-model="search_query" class="form-control search-input-employee" placeholder="Search" name="Search"> -->
                            <ul class="o-filter-area">
                                <li v-if="getEditPower() && getPower('editEmployee')">
                                    <a  @click ="editEmployee()" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i aria-hidden="true" class="fa fa-pencil"></i> Edit User Profile</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" v-if="wishlistLock || ignorelistLock" @click="scheduleWishlist()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-star" aria-hidden="true"></i> Wishlist</a>
                                </li>
                                <li>
                                    <a v-if="getLogsAccess()" href="javascript: void(0)" @click="scheduleSmslog()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-envelope-o" aria-hidden="true"></i> Notify log </a>
                                </li>
                                <li>
                                    <a v-if="getLogsAccess()" href="javascript: void(0)" @click="scheduleActionlog()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Action </a>
                                </li>
                                <!-- <li>
                                    <a href="javascript: void(0)" @click="goToJobList()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li> -->
                            </ul>
                        </div>
                        <div class="row mt-5">
                            <ul class="o-filter-area">
                                <li v-if="getPower('employeeSearch')">
                                <input type="text" v-model="search_query" class="form-control search-input-employee" placeholder="Search" name="Search">
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="c-common-space c-responsive-fixwidth">
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="o-customSelect o-schedule-month">
                                <label class="o-inline-datepicker">
                                    <span class="o-inline-datepicker-label">Select month:</span>
                                </label>
                                <a href="javascript: void(0)" @click="prevMonth()"><i class="fa fa-arrow-circle-left btn-arraw-adjust" aria-hidden="true"></i></a>
                            
                            
                                <el-date-picker
                                    v-model="selectedDate"
                                    @change="convertDateString()"
                                    class="o-inline-datepicker-icon"
                                    type="month"
                                    format="MMMM yyyy"
                                    placeholder="">
                                </el-date-picker>

                                <a @click="nextMonth()" href="javascript: void(0)"><i class="fa fa-arrow-circle-right btn-arraw-adjust" aria-hidden="true"></i></a>
                                <a href="javascript: void(0)" @click="select45Days()" :class="(subTab=='days')?'selected-tab c-common-btn':'c-common-btn'">Next 45 Days</a>
                                <a @click="loadRepotJson()" href="javascript: void(0)" class="c-common-btn c-solid-btn--small">Report History</a>
                            
                            </div>
                            
                        </div>

                        <div class="col-sm-4 text-right">
                        </div>
                    </div>
                </div>
                <div v-if="searchOpen" class="c-common-space u-margin-bottom-0 c-responsive-fixwidth">
                    <div class="row">
                        <div class="col-md-12 o-tab-area">
                            <ul class="o-tab-view o-tab-view--text">
                                <li><a href="javascript: void(0)" :class="{'active':(this.tab=='scheduled')?true:false}" @click="changeTab('scheduled')">Scheduled</a></li>
                                <li><a href="javascript: void(0)" :class="{'active':(this.tab=='declined')?true:false}" @click="changeTab('declined')">Declined</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Heading Section -->
            <employeeSearch v-if="!searchOpen" :searchString="search_query" :requestPage="'emp-schedule'"></employeeSearch>
        </div>
        <!-- /Main Body Content area -->

       <!-- :subTab="subTab" :userSelectMonth="monthSort" -->
       <div v-if="searchOpen">
           <tabSchedule :employeeUserId="userId" :userDateFormat="userDateFormat" :userTimeFormat="userTimeFormat" :scheduleData="scheduleData" v-if="this.tab == 'scheduled'"/>
           <tabDeclined :userDateFormat="userDateFormat" :userTimeFormat="userTimeFormat" :userSelectMonth="monthSort" :scheduleData="scheduleData" v-if="this.tab == 'declined'"/>
       </div>       
    </div>
    <div v-else>
        <NotAllowed />
    </div>
    <modal
        name="employee-report-history-modal"
        height="auto"
        width="75%"
        :scrollable="false"
        class="modal-dialog modal-lg modal--custom"
        @closed="openCloseReportHistoryModal('close')"
      >
        <div tabindex="-1" role="dialog">
          <div role="document">
            <div class="modal-content">
              <div class="modal-header text-center">
                <button
                  @click="openCloseReportHistoryModal('close')"
                  type="button"
                  class="close custom-modal--close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h1 class="modal-title">Employee Report History</h1>
              </div>

              <div class="modal-body mt-15">
                <iframe :src="employeeReportHistoryUrl" frameborder="0" style="width:100%; height:70vh;"></iframe>
              </div>              
            </div>
          </div>
        </div>
      </modal>
  </div>
</template>

<script>
    import tabSchedule from './tabSchedule';
    import tabDeclined from './tabDeclined';
    import employeeSearch from '../employees/employeeSearch';

    import { mapGetters, mapActions } from 'vuex';
    import { global } from '../../global.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import {bus} from '../../main';
    import NotAllowed from '@/components/NotAllowed';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userRoleSlug: 'userRoleSlug',
                employeeId: 'employeeId',
            }),

            searchOpen(){
                // console.log(this.search_query.length);
                return (this.search_query.length==0)?true:false;
            },
        },
        components: {
            'tabSchedule': tabSchedule,
            'tabDeclined': tabDeclined,
            'employeeSearch':employeeSearch,
            'NotAllowed': NotAllowed
        },
        data() {
            return {
                employeeReportHistoryUrl: '',
                isEmployeeAllowed: true,
                loading:false,
                profileImage:'',
                employeePhone:'',
                employeeName:'',
                userId:'',
                tab: "scheduled",
                subTab:'days',
                imagePath: '',
                monthSort: moment().format('YYYY-MM-DD HH:mm:ss'),
                selectedDate:new Date(),
                getBaseURL: '',
                wishlistLock:false,
                ignorelistLock:false,
                scheduleData:{
                    month:new Date(),
                    subTab:'days'
                },
                able_to_access_logs:false,
                search_query:'',
                rdxlFileUrl: '',
                userDateFormat:null,
                userTimeFormat:null,
                employeeDetails: null,
                isUnAuthorized: 0
            }
        },
        methods: {
            openCloseReportHistoryModal(type) {
                if (type == "open") {
                    // this.addNoteDilog = true;
                    this.$modal.show("employee-report-history-modal");
                } else {
                    // this.addNoteDilog = false;
                    this.$modal.hide("employee-report-history-modal");
                }
            },
            async getRdlxJsonUrl(){
                await service.get('getEmployeeReportUrl', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                   this.rdxlFileUrl = res.data.result;	
                   console.log(this.rdxlFileUrl);
                }).catch((err) => {
                    console.log(err);
                });
            },
            async loadRepotJson(){
                this.loading = true;
                await this.getRdlxJsonUrl();
                await service.get('call/empoyeeConfirmedCallsJsonPayload', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': atob(this.$route.params.empId)
                })
                .then((res) => {
                    // console.log(res.data);
                    this.loading=false;
                    let data_source = res.data.result;
                    let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', this.rdxlFileUrl, data_source);
                    this.employeeReportHistoryUrl = redirectUrl
                    // console.log(this.employeeReportHistoryUrl);
                    this.openCloseReportHistoryModal('open');
					// window.open(redirectUrl, "_blank");  	
                }).catch((err) => {
                    this.loading=false;
                    console.log(err);
                });
            },
            goToJobList(){
                this.$router.push({
                    path: `/jobList`
                });
            },
            select45Days(){
                this.subTab='days';  
                this.scheduleData={
                   month:this.monthSort,
                   subTab:this.subTab
                }   
            },
            convertDateString(){
                this.monthSort=moment(this.selectedDate).format('YYYY-MM-DD HH:mm:ss');
                this.subTab='month';
                // console.log('data',this.monthSort);
                this.scheduleData={
                   month:this.monthSort,
                   subTab:this.subTab
                } 
            },
            prevMonth(){
                // this.selectedDate=moment(this.selectedDate).subtract(1, 'M').format('YYYY-MM-DD HH:mm:ss');
                this.selectedDate=moment(this.selectedDate).subtract(1, 'M').toISOString();
                this.monthSort=moment(this.selectedDate).format('YYYY-MM-DD HH:mm:ss');   
                this.subTab='month';   
                this.scheduleData={
                   month:this.monthSort,
                   subTab:this.subTab
                }       
            },
            nextMonth(){
                // this.selectedDate=moment(this.selectedDate).add(1, 'M').format('YYYY-MM-DD HH:mm:ss');
                this.selectedDate=moment(this.selectedDate).add(1, 'M').toISOString();
                this.monthSort=moment(this.selectedDate).format('YYYY-MM-DD HH:mm:ss');
                this.subTab='month';
                this.scheduleData={
                   month:this.monthSort,
                   subTab:this.subTab
                } 
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            getEditPower(){
                if(this.employeeId == atob(this.$route.params.empId) || this.userRoleSlug!='employee'){
                    return true;
                }
                return false;
            },
            getLogsAccess(){
                if(this.able_to_access_logs || this.userRoleSlug!='employee'){
                    return true;
                }
                return false;
            },
            editEmployee(){
                this.$store.dispatch('setEditEmployeesFrom', 'empSchedule');
                this.$router.push({
                    'path': '/editEmployee/'+this.$route.params.empId
                });
            },
            changeTab(newTab) {
                this.tab = newTab;
                this.subTab='days';
            },
            scheduleWishlist() {
                this.$store.dispatch('setWishListType', 'schedule');
                this.$router.push({
                    path: `/wishlist/`+this.$route.params.empId
                });
            },
            scheduleSmslog() {
                this.$store.dispatch('setNotificationType', 'employeeAction');
                this.$router.push({
                    path: `/notifyLog/`+this.$route.params.empId
                });
            },
            scheduleActionlog() {
                this.$store.dispatch('setActionTypeForLog', 'employeeAction');
                this.$router.push({
                    path: `/actionlog/`+this.$route.params.empId
                });
            },
            async getEmpDetails() {
                this.$Progress.start();
                await service.get('employee/' + atob(this.$route.params.empId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    //this.detailEmployee = res.data.result;
                    this.employeeDetails = res.data.result;
                    this.profileImage= this.employeeDetails.employable.image;
                    this.employeeName=this.employeeDetails.employable.first_name+" "+this.employeeDetails.employable.last_name;
                    let fname = this.employeeDetails&&this.employeeDetails.employable&&this.employeeDetails.employable.first_name?this.employeeDetails.employable.first_name:'Employee Details';
                    let lname = this.employeeDetails&&this.employeeDetails.employable&&this.employeeDetails.employable.last_name?this.employeeDetails.employable.last_name:'';
                    document.title = lname + ', ' + fname;
                    this.employeePhone=this.employeeDetails.employable.phones;
                    this.userId=this.employeeDetails.employable.id;
                    this.able_to_access_logs =this.employeeDetails.employee_status.able_to_access_logs;
                    this.userDateFormat = this.employeeDetails.date_format;
                    this.userTimeFormat = this.employeeDetails.time_format;
                    //console.log('UserID',this.userId);
                    //console.log(res);
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        // this.isUnAuthorized += 1;
                        // this.isEmployeeAllowed = false;
                        // if(this.isUnAuthorized == 1) {
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({ path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                        // }
                    }
                });
            }
        },
        beforeMount() {
            if(!this.userToken || this.userToken == '' ) {
                this.$router.push('/');
            }
        },
        async created() {
            await this.getRdlxJsonUrl();
            // console.log(this.rdxlFileUrl);
            await this.getEmpDetails();
            this.getBaseURL = global[0].IMAGE_URL;
            await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {
                //this.turnoverTime=res.data.result.turnover;
                if (res.data.result.wishlist_lock == 1) {
                    this.wishlistLock = true;
                } else {
                    this.wishlistLock = false;
                }
                this.ignorelistLock=(res.data.result.ignorelist_lock == 1)?true:false;    
                //console.log(this.wishlistLock);
            }).catch((err) => {
                console.log(err);
                if(err.response&&err.response.status&&err.response.status==403) {
                    this.isUnAuthorized += 1;
                    this.isEmployeeAllowed = false;
                    if(this.isUnAuthorized == 1) {
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                }

            });

            bus.$on('onsearchAction', async (data) => {
                if(data=='emp-schedule'){
                    this.search_query='';
                    await this.getEmpDetails();
                }
                // this.getEmpDetails();
            });
            //console.log(atob(this.$route.params.empId));
        },
        beforeDestroy() {
            this.loading = false;
            this.profileImage = '';
            this.employeePhone = '';
            this.employeeName = '';
            this.userId = '';
            this.tab = "scheduled";
            this.subTab = 'days';
            this.imagePath = '';
            this.monthSort = moment().format('YYYY-MM-DD HH:mm:ss');
            this.selectedDate = new Date();
            this.getBaseURL = '';
            this.wishlistLock = false;
            this.ignorelistLock = false;
            this.scheduleData = {
                month:new Date(),
                subTab:'days'
            }
            this.able_to_access_logs = false;
            this.search_query = '';
            this.rdxlFileUrl = '';
            this.userDateFormat = null;
            this.userTimeFormat = null;
        },
    }

</script>
<style scoped>
.btn-arraw-adjust{
    font-size: 30px;
    padding: 5px 0px 0px 0px;
}
.c-common-btn {
    font-weight: 500;
    padding: 8px 7px;
    border-radius: 5px;
    border: #BACCDD 1px solid;
    background-color: #fff;
    display: inline-block;
}
.selected-tab{
    border-color: #FB8B03 !important;
    color: #FB8B03 !important;
}
.selected-tab input{
    border-color: #FB8B03 !important;
    color: #FB8B03 !important;
}
.search-input-employee{
    margin: 1px;
    height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/schedule.vue